import Tippy from "@tippyjs/react";
import styled, { keyframes } from "styled-components";

const pulseBorder = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(217, 51, 51, 0.7);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(217, 51, 51, 0);
  }
`;

export const TaskContainer = styled.div`
  &.critical {
    border: 4px solid #d93333 !important;
    animation: ${pulseBorder} 1.2s cubic-bezier(0.66, 0, 0, 1) infinite !important;
  }

  display: flex;
  width: 235.31px;
  min-height: 68px;
  padding: 10px;
  position: relative;
  font-family: Sora;

  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
  background-color: ${({ status }) =>
    status === "late"
      ? "#FDD6CD"
      : status === "done" || status === "doneLate"
      ? "#CFF8E7"
      : status === "doing"
      ? "#FFFDD3"
      : "white"};

  flex-direction: column;

  border: ${({ status }) =>
    status === "late"
      ? " 1.31774px solid #B92626"
      : status === "done"
      ? "1.31774px solid #118052"
      : status === "doneLate"
      ? "1.31774px solid #D93333"
      : status === "doing"
      ? "1.31774px solid #807228"
      : status === "pending"
      ? "1.31774px solid #585E66"
      : "1.31774px solid #585E66"};
`;

export const Avatar = styled.img`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 22.59px;
  height: 22.59px;
  border-radius: 50%;
  background: lightblue;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  justify-content: space-between;
`;

export const Status = styled.div`
  border-radius: 6px;
  padding: 0 6px 0 6px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2.82373px;
  color: ${({ status }) =>
    status === "done"
      ? "#EFF1F5"
      : status === "pending"
      ? "#7E858F"
      : status === "none"
      ? "#EFF1F5"
      : status === "doing"
      ? "#786A23"
      : status === "late"
      ? "#D93333"
      : "#EFF1F5"};

  span {
    font-weight: 600;
    font-size: 10.35px;
  }

  background-color: ${({ status }) =>
    status === "done"
      ? "#118052"
      : status === "pending"
      ? "#EFF1F5"
      : status === "none"
      ? "#585E66"
      : status === "doing"
      ? "#F8E47C"
      : status === "late"
      ? "#FFBAAB"
      : status === "doneLate"
      ? "#9F2D1D"
      : "#585E66"};
`;

export const TaskLabel = styled.div`
  word-break: break-word;
  text-align: center;
  margin: 12.24px 27.3px 11.3px 27.3px;
  font-size: 11.29px;
  text-transform: uppercase;
  width: 180.72px;
  min-height: 14.12px;
  font-weight: 600;

  color: ${({ status }) =>
    status === "done"
      ? "#118052"
      : status === "doneLate"
      ? "#9F2D1D"
      : status === "pending"
      ? "#585E66"
      : status === "doing"
      ? "#786A23"
      : status === "late"
      ? "#B92626"
      : "#585E66"};
`;

export const ImageContainer = styled.img`
  border-radius: 50%;
  max-width: 32px;
  max-height: 32px;
`;

export const Stats = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    color: ${({ status }) =>
      status === "done"
        ? "#118052"
        : status === "doneLate"
        ? "#8A3E33"
        : status === "pending"
        ? "#7E858F"
        : status === "doing"
        ? "#786A23"
        : status === "late"
        ? "#D93333"
        : "#7E858F"};
  }

  path {
    stroke: ${({ status }) =>
      status === "done"
        ? "#118052"
        : status === "doneLate"
        ? "#8A3E33"
        : status === "pending"
        ? "#7E858F"
        : status === "late"
        ? "#B92626"
        : status === "doing"
        ? "#786A23"
        : "#7E858F"};
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 17px;
  line-height: 21px;
  font-weight: 600;
  height: min-content;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: min-content;

  //opacity: ${({ accountable }) => (accountable === "Ninguém" ? "0.3" : "1")};
`;

export const TaskData = styled.div`
  display: flex;
  min-width: 107.3px;
  align-items: center;

  svg {
    height: 14px;
  }

  span {
    font-size: 11.2949px;
    font-weight: 600;
    margin-left: 1px;
  }
`;

export const TaskPeriod = styled.div`
  width: 85.65px;
  height: 22.59px;
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 10.35px;
  line-height: 13.05px;
  border-radius: 2.8375px;
  display: flex;
  align-items: center;
  justify-content: ${({ job }) => (!job ? "center" : null)};
  svg {
    margin-left: 5.5px;
  }

  span {
    display: block;
    margin-left: 2px;
  }

  background-color: ${({ status }) =>
    status === "late" || status === "doneLate" ? "#A80707" : "#49B446"};

  color: #ffffff;
`;
const anim = keyframes`
  from {
    transform: translateY(-5px);
  }
  to {
    transform: translateY(-10px);
  }
`;

export const StyledTippy = styled(Tippy)`
  font-size: 12px;
  text-align: start;
  color: #fff;
  animation: ${anim} 400ms ease 0s 1 normal both running;
  background-color: #585e66;

  & > .tippy-arrow {
    color: #585e66;
  }
`;
